export * from './header/header.component';
export * from './footer/footer.component';
export * from './privacy/privacy.component';
export * from './terms/terms.component';



// WEBPACK FOOTER //
// ./src/components/shared/index.ts